module.exports = __webpack_public_path__ + "img/Monte_Kope_43.59b98abb.jpg";